import { IChartApi, IPaneApi, Time } from 'lightweight-charts'

/** A pane row consists of three cells: left price scale, pane, right price scale. */
const PANE_CELL_INDEX = 1

type ChartWithPanes = Pick<IChartApi, 'panes'>

/**
 * Drawing area of a pane (price scales are not included).
 * `IPaneApi.getHTMLElement()` returns the whole row of the pane, so the pane cell is taken from it.
 * Returns `null` while the pane is not rendered yet.
 */
export const getPaneElement = (pane?: IPaneApi<Time> | null): HTMLElement | null => {
    const paneCell = pane?.getHTMLElement()?.children[PANE_CELL_INDEX]
    return paneCell instanceof HTMLElement ? paneCell : null
}

/**
 * Drawing areas of the chart panes, the index in the result is the index of the pane.
 * Panes are rendered on the next frame after they are created, such panes (always the last ones) are skipped.
 */
export const getPaneElements = (chartApi?: ChartWithPanes | null): HTMLElement[] => {
    if (!chartApi) return []
    const elements: HTMLElement[] = []
    for (const pane of chartApi.panes()) {
        const element = getPaneElement(pane)
        if (!element) break
        elements.push(element)
    }
    return elements
}
